<template>
  <div>
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" color="white">
          <v-icon small class="pr-4">mdi-menu-down</v-icon>Lägg till
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          @click="item.action"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-dialog :value="showCreateManually" width="600" persistent>
      <ReplacementCreateModal
        v-if="showCreateManually"
        @close="showCreateManually = false"
      />
    </v-dialog>

    <v-dialog :value="showReplacementsFromCommando" width="1000" persistent>
      <ReplacementImportFromCommando
        v-if="showReplacementsFromCommando"
        @close="showReplacementsFromCommando = false"
      />
    </v-dialog>
  </div>
</template>

<script>
import ReplacementCreateModal from './ReplacementCreateModal'
import ReplacementImportFromCommando from './ReplacementImportFromCommando'

export default {
  name: 'ReplacementCreateDropdown',

  components: {
    ReplacementCreateModal,
    ReplacementImportFromCommando
  },

  data: () => ({
    showCreateManually: false,
    showReplacementsFromCommando: false
  }),

  computed: {
    items() {
      return [
        {
          title: 'Manuellt',
          action: () => {
            this.showCreateManually = true
          }
        },
        {
          title: 'Från commando',
          action: () => {
            this.showReplacementsFromCommando = true
          }
        }
      ]
    }
  }
}
</script>
